import { fetchPublicAPI } from "hooks/usePublicAPI";

import {
  parseHandoffStatus,
  type HandoffStatus,
  type SignedHandoff,
} from "./handoff";

/** Whether the lead behind a signed handoff still has to prove who they
 * are. A failed request reads as settled. */
export async function fetchHandoffStatus(
  handoff: SignedHandoff,
): Promise<HandoffStatus> {
  try {
    const raw = await fetchPublicAPI<unknown>("/leads/handoff-status", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        event_id: handoff.eventId,
        ped: handoff.ped,
        sig: handoff.sig,
        exp: handoff.exp,
      }),
    });
    return parseHandoffStatus(raw);
  } catch {
    return { kind: "settled" };
  }
}
